import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    filter: "brightness(0.8)", //blur(1.5px)
    backgroundColor: theme.palette.background.paper,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    zIndex: -100
  }
}));
